import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { Swiper, SwiperSlide } from 'swiper/react';

import { geoip, programBoardList } from '@/network/apis/apiUri';
import useContent from '@/localization/data_export';
import * as URL from '@/constant/kollusUrl';
import { db } from '../utils/schedule';

const scheduleTabs = ['world', 'korea', 'un', 'radio'];

export default function Schedule() {
  const { mode } = useSelector((state) => state);

  const anchorTitle = useContent(['global', 'anchor', 'title']);
  const boardCustomType = useContent('boardCutomType');

  const boardId = boardCustomType ? boardCustomType.csv.find((v) => v.type === 27).id : 912;

  const playerWarpRef = useRef();
  const controllerRef = useRef();

  const [selectTab, setSelectTab] = useState('world');
  const [playerUrl, setPlayerUrl] = useState({
    world: URL.LIVE_WORLD_KOREA,
    korea: URL.LIVE_KOREA,
    un: URL.LIVE_UN,
    radio: URL.LIVE_RADIO,
  });

  const kollusPlayerLoad = (e) => {
    const el = e.currentTarget;
    const controller = new window.VgControllerClient({
      target_window: el.contentWindow,
    });

    controllerRef.current = undefined;
    controller
      .on('loaded', () => {
        controller.set_control_visibility(false);
      })
      .on('ready', () => {
        controllerRef.current = controller;
        if (playerWarpRef.current && playerWarpRef.current.matches(':hover')) controller.play();
      });
  };

  const { isSuccess, data } = useQuery(['main', 'schedule', selectTab], async () => db.get(selectTab, mode), {
    retry: false,
    staleTime: 1000 * 60,
    refetchInterval: 1000 * 60,

    enabled: !!mode && !!selectTab,
  });

  const { isSuccess: bannerSuccess, data: banner } = useQuery(
    ['main', 'banner', 'square'],
    async () => {
      const response = await programBoardList({
        board_id: boardId,
        lan_code: mode,
        is_order_allow: true,
        page_info: { row_count: 15, number: 0 },
      });

      return response.data.item
        .filter((item) => (mode === 'en' ? item.content !== '2' : item.content !== '1'))
        .map((item) => ({
          id: item.board_item_id,
          image: item.image.url,
          title: item.title,
          link: item.url_link[0],
        }));
    },
    {
      retry: false,
      enabled: !!boardId && !!mode,
      staleTime: 1000 * 60 * 3,
    }
  );

  useEffect(() => {
    geoip()
      .then(({ data: { isKorean } }) => {
        setPlayerUrl((prev) => ({ world: isKorean ? URL.LIVE_WORLD_KOREA : URL.LIVE_WORLD_GLOBAL, ...prev }));
      })
      .catch(() => console.error('[ERROR] GEO_IP API'));
  }, []);

  return (
    <div className="section-wrapper">
      <div className="schedule-wrapper">
        <div className="schedule-title">
          <h2>
            Today <em>Schedule</em>
          </h2>
          <ul>
            {scheduleTabs.map((data) => (
              <li key={`tabs_${data}`}>
                <button type="button" onClick={() => setSelectTab(data)} data-active={data === selectTab}>
                  {data.toUpperCase()}
                </button>
              </li>
            ))}
          </ul>
          <a
            href={`https://company.arirang.com/join/watch?subPage=${selectTab === 'radio' ? 'listen' : 'watch'}`}
            target="_blank"
            rel="noreferrer"
            className="foundation-link"
            title={anchorTitle}
          >
            {selectTab === 'radio' ? 'HOW TO LISTEN' : 'HOW TO WATCH'}
          </a>
        </div>
        <div className="schedule-content">
          <Link
            to={selectTab === 'radio' ? '/radio' : '/live'}
            ref={playerWarpRef}
            title={anchorTitle}
            onMouseOver={(e) => controllerRef.current && controllerRef.current.play()}
            onMouseOut={() => controllerRef.current && controllerRef.current.pause()}
          >
            <div className="live-player" data-img-src={selectTab}>
              <iframe
                title="kollus player"
                className="kollus"
                src={playerUrl[selectTab]}
                onLoad={kollusPlayerLoad}
                allow="autoplay; encrypted-media; fullscreen;"
                allowFullScreen={false}
              />
            </div>
          </Link>
          {isSuccess && (
            <div className="live-schedule">
              {data.map((item) => (
                <Link to={item.link} key={item.id} title={anchorTitle}>
                  <div className="sch-container">
                    <div className="time-box">
                      <time>{item.broadTime}</time>
                      <span>{item.timeLocale}</span>
                    </div>
                    <div className="info-box">
                      {item.category && <span>{item.category}</span>}
                      <h3>{item.title}</h3>
                      <div>
                        {item.isLive ? <span className="live">LIVE</span> : <span className="next">NEXT</span>}
                        {item.isFirst && <span className="first">FIRST</span>}
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="square-banner">
        {bannerSuccess && (
          <div className="img-wrapper">
            {banner.length > 1 ? (
              <Swiper slidesPerView={1} loop navigation pagination={{ clickable: true }}>
                {banner.map((item) => (
                  <SwiperSlide key={item.id}>
                    <a href={item.link} target="_blank" rel="noreferrer" title={anchorTitle}>
                      <img
                        src={item.image}
                        alt=""
                        width="300"
                        height="281"
                        onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                      />
                    </a>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <a href={banner[0].link} target="_blank" rel="noreferrer" title={anchorTitle}>
                <img
                  src={banner[0].image}
                  alt=""
                  width="300"
                  height="281"
                  onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                />
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
